var classes = {"regionItem":"_0VTmW","regionItemCountry":"kMwFV","languageMenuContentListLanguageItemLink":"_49wes","regionItemLanguage":"q1jj3","regionItemLanguageDivider":"nY6c7","languageMenuContentListLanguageItemLinkInactive":"aPTcL","regionItemLanguageDividerInactive":"pPWSG","languageMenuContentLanguageList":"BXqRI"};

export { classes as default };
